import { USER_ROLES } from '@bagonboard/wiseman';

export const constraints = {
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    email   : { message: '^Invalid email' },
  },
  name: {
    presence: { allowEmpty: false, message: 'is required' },
  },
  password: {
    presence: { allowEmpty: false, message: 'is required' },
    length  : {
      minimum: 6,
      message: 'must be at least 6 characters',
    },
  },
  role: {
    presence: { allowEmpty: false, message: 'is required' },
  },
};

export const roles = [
  { value: USER_ROLES.SUPER_ADMIN, text: 'Super Admin' },
  { value: USER_ROLES.ADMIN, text: 'Admin' },
  { value: USER_ROLES.SUPPORT, text: 'Support' },
  { value: USER_ROLES.AGENT, text: 'Agent' },
  { value: USER_ROLES.COURIER_ADMIN, text: 'Courier Admin' },
  { value: USER_ROLES.COURIER_AGENT, text: 'Courier Agent' },
  { value: USER_ROLES.HOST_ADMIN, text: 'Host Admin' },
  { value: USER_ROLES.HOST_AGENT, text: 'Host Agent' },
  { value: USER_ROLES.TRAVEL_COMPANY_ADMIN, text: 'Travel Company Admin' },
  { value: USER_ROLES.TRAVEL_COMPANY_AGENT, text: 'Travel Company Agent' },
  { value: USER_ROLES.USER, text: 'User' },
  // LAF ROLES
  { value: USER_ROLES.HANDLING_COMPANY_MANAGER, text: 'L&F manager' },
  { value: USER_ROLES.HANDLING_COMPANY_AGENT, text: 'L&F agent' },
  { value: USER_ROLES.HANDLING_COMPANY_OPERATOR, text: 'L&F operator' },
  { value: USER_ROLES.HANDLING_COMPANY_OBSERVER, text: 'L&F observer' },
];
